import { UpdateChargePointOcppConfigurationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/update-charge-point-ocpp-configuration.model';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

interface ReadonlyFormWrapperProps {
  data: UpdateChargePointOcppConfigurationModel & { chargePointId: string };
  children: React.ReactNode;
}

export const ReadonlyFormWrapperComponent = ({
  data,
  children,
}: ReadonlyFormWrapperProps): React.JSX.Element => {
  const methods = useForm({
    defaultValues: data,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
